import { LoadingFallback } from 'components/loading/LoadingFallback';
import { createRoot } from 'react-dom/client';

import('services/hotReload');
import('components/importCss');

import('react').then((React) => {
  import('Root/Root').then(({ default: Root }) => {
    const rootContainer = document.getElementById('app-mount');

    if (!rootContainer) {
      throw new Error('Root container not found');
    }

    createRoot(rootContainer).render(
      <React.Suspense fallback={<LoadingFallback />}>
        <Root />
      </React.Suspense>
    );
  });
});
